import type { ErrorInfo, ReactNode } from "react";
import { Component } from "react";
import FireworksModule from "react-canvas-confetti/dist/presets/fireworks";

import { logger } from "@/lib/logger";
import { useConfettiStore } from "@/store/confettiStore";

const Fireworks =
  typeof FireworksModule === "function"
    ? FireworksModule
    : (FireworksModule as unknown as { default: typeof FireworksModule }).default;

/** Confetti 렌더링 실패 시 앱 전체가 죽지 않도록 격리 */
class ConfettiErrorBoundary extends Component<{ children: ReactNode; onError: () => void }, { hasError: boolean }> {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    logger.warn({
      domain: "confetti",
      message: "렌더링 에러 — 무시",
      error,
      data: { componentStack: info.componentStack },
    });
    this.props.onError();
  }

  render() {
    if (this.state.hasError) {
      return null;
    }

    return this.props.children;
  }
}

/** 앱 루트에 한 번 마운트 — confettiStore.fire()로 어디서든 트리거 */
export function GlobalConfetti() {
  const active = useConfettiStore(state => state.active);

  if (!active) {
    return null;
  }

  return (
    <ConfettiErrorBoundary onError={() => useConfettiStore.setState({ active: false })}>
      <div className="pointer-events-none fixed inset-0 z-[9999]">
        <Fireworks autorun={{ speed: 3, duration: 3000 }} />
      </div>
    </ConfettiErrorBoundary>
  );
}
